import {FETCH_MENU_LIST} from '../actions/types.js';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case FETCH_MENU_LIST:
            return action.payload;
        default:
            return state;
    }
}